export const COOKIE_CONSENT_STORAGE_KEY = 'eco.cookie.consent';

export const getCookieConsent = () => {
  try {
    return JSON.parse(localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) || 'null');
  } catch {
    return null;
  }
};
